// base
import produce from 'immer';

import { createReducer } from 'typesafe-actions';

// action
import {
  AuthAction,
  userPageAction,
  check,
  login,
  logout,
  refresh,
  pwUpdateAction,
  userDeleteAction,
  pwCheckAction
} from '../actions/authAction';

import {
  UserPageState,
  UserPageData,
  initResponseUserPageData,
  UserPwState,
  UserData,
  UserPw,
  initResponseUserPwPageData,
  UserPwCheck
} from '../models/authModel';

export interface AuthState {
  pageLoading: boolean;
  isRefresh: boolean;
  isLogin?: boolean;
  message: string;
  user?: UserData;
  UserPw?: UserPw;
  UserPwCheck?: UserPwCheck;
}

// reducers
const initialState: AuthState = {
  pageLoading: false,
  isLogin: undefined,
  isRefresh: false,
  user: undefined,
  message: '',
  UserPw: undefined,
  UserPwCheck: undefined
};

export const authReducer = createReducer<AuthState, AuthAction>(initialState)
  .handleAction(login.success, (state, action) =>
    produce(state, draft => {
      draft.isLogin = true;
      draft.user = action.payload;
    })
  )
  .handleAction(login.request, (state, action) =>
    produce(state, draft => {
      draft.isLogin = false;
      draft.message = '';
    })
  )
  .handleAction(login.failure, (state, action) =>
    produce(state, draft => {
      draft.isLogin = false;
      draft.message = action.payload;
    })
  )
  .handleAction(check.success, (state, action) =>
    produce(state, draft => {
      const { isLogin, user } = action.payload;
      draft.isRefresh = false;
      draft.isLogin = isLogin;
      draft.user = user;
    })
  )
  .handleAction(refresh.request, (state, action) =>
    produce(state, draft => {
      draft.isRefresh = true;
    })
  )
  .handleAction(refresh.success, (state, action) =>
    produce(state, draft => {
      draft.user = action.payload;
    })
  )
  .handleAction(logout.success, state =>
    produce(state, draft => {
      draft.isLogin = false;
      draft.user = undefined;
    })
  )
  .handleAction(userDeleteAction.success, state =>
    produce(state, draft => {
      draft.isLogin = false;
      draft.user = undefined;
    })
  );

export const mypageReducer = createReducer<UserPageState, AuthAction>(
  initResponseUserPageData
)
  .handleAction(userPageAction.success, (state, action) =>
    produce(state, draft => {
      const data: UserPageData = action.payload;
      draft.userPage = data;
    })
  )
  .handleAction(pwCheckAction.success, (state, action) =>
    produce(state, draft => {
      const data = action.payload;
      draft.result = data;
    })
  );
export const userPwReducer = createReducer<UserPwState, AuthAction>(
  initResponseUserPwPageData
).handleAction(pwUpdateAction.success, (state, action) =>
  produce(state, draft => {
    const data: UserPw = action.payload;

    draft.userPwPage = data;
  })
);
